import React, { useState } from "react";
import logo from "../../Assets/logo/wbclogo.svg";
import { NavLink } from "react-router-dom";
import { FiMenu, FiHome } from "react-icons/fi";
import { FaRegUserCircle } from "react-icons/fa";
import { MdMenuBook, MdWorkOutline } from "react-icons/md";
import { FaRegNewspaper } from "react-icons/fa6";
import { BiMessageDetail } from "react-icons/bi";

const items = [
  { to: "/admin/home", label: "Overview", icon: <FiHome size={18} /> },
  { to: "/admin/courses", label: "Courses", icon: <MdMenuBook size={18} /> },
  {
    to: "/admin/articles",
    label: "Articles",
    icon: <FaRegNewspaper size={18} />,
  },
  { to: "/admin/careers", label: "Careers", icon: <MdWorkOutline size={18} /> },
  {
    to: "/admin/inquiries",
    label: "Inquiries",
    icon: <BiMessageDetail size={18} />,
  },
];

const Sidebar = () => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <aside
      className={`relative h-screen flex-shrink-0 transition-all shadow-lg duration-300 ${
        collapsed ? "w-16" : "w-64"
      }`}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-[#eef3ff] via-[#f7f5ff] to-white pointer-events-none">
        <div className="pointer-events-none absolute -top-24 -left-24 h-72 w-52 rounded-full bg-[#064585]/20 blur-3xl" />
        <div className="pointer-events-none absolute bottom-0 -left-16 h-96 w-36 rounded-full bg-[#5989C8]/20 blur-3xl" />
      </div>

      <div
        className={`relative z-10 h-full flex flex-col justify-between p-3 ${
          collapsed ? "items-center" : "items-stretch"
        }`}
      >
        {/* logo and menu */}
        <div>
          <div
            className={`flex items-center justify-between gap-2 px-2 py-3 rounded-xl ${
              collapsed ? "w-12 mx-auto" : "w-full"
            } bg-white/40 backdrop-blur border border-[#5989C8]/10 shadow-sm`}
          >
            <div className="flex items-center gap-2">
              {!collapsed ? (
                <img src={logo} alt="logo" className="h-8" />
              ) : (
                <button
                  onClick={() => setCollapsed((s) => !s)}
                  className="p-2 rounded-md hover:bg-white/60 transition"
                >
                  <FiMenu size={20} />
                </button>
              )}
            </div>
            {!collapsed && (
              <button
                onClick={() => setCollapsed((s) => !s)}
                className="p-2 rounded-md hover:bg-white/60 transition"
              >
                <FiMenu size={20} />
              </button>
            )}
          </div>

          {/* Menu */}
          <nav className="mt-4 space-y-2">
            {items.map((menu, idx) => (
              <div key={idx} className="group relative">
                <NavLink
                  to={menu.to}
                  className={({ isActive }) =>
                    `flex items-center gap-3 px-2 py-2 rounded-lg transition-all duration-200 ${
                      isActive
                        ? "bg-gradient-to-r from-[#064585] via-[#5989C8] to-[#64a2ff] text-white shadow-md"
                        : "text-slate-700 hover:bg-white/60"
                    } ${collapsed ? "justify-center" : ""}`
                  }
                  title={collapsed ? menu.label : undefined}
                  aria-label={menu.label}
                >
                  <div className="flex items-center justify-center w-8 h-8 rounded-md">
                    {menu.icon}
                  </div>

                  {!collapsed && (
                    <span className="text-sm font-medium">{menu.label}</span>
                  )}
                </NavLink>

                {collapsed && (
                  <div className="absolute left-full top-1/2 -translate-y-1/2 ml-3 opacity-0 group-hover:opacity-100 transform translate-x-0 group-hover:translate-x-1 transition-all duration-150 z-50">
                    <div className="bg-gradient-to-r from-[#064585] to-[#64a2ff] text-white text-xs font-medium py-1 px-3 rounded-md shadow-md whitespace-nowrap">
                      {menu.label}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </nav>
        </div>

        {/* profile  */}
        <div className="mt-4">
          <div
            className={`flex items-center gap-3 px-2 py-3 rounded-lg transition-colors ${
              collapsed ? "justify-center" : "justify-start"
            } bg-white/40 backdrop-blur border border-[#5989C8]/10 shadow-sm`}
          >
            <FaRegUserCircle className="text-[#064585] w-8 h-8" />
            {!collapsed && (
              <div className="text-left">
                <div className="text-sm font-semibold">
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#064585] via-[#5989C8] to-[#64a2ff]">
                    Manas Ranan
                  </span>
                </div>
                <div className="text-xs font-light text-slate-600">
                  manasranjan@gmail.com
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
